import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionDetails,
  Box,
  Divider,
  List,
  ListItem,
  ListItemText,
  Tab,
  Tabs,
  Typography,
  useTheme,
} from "@mui/material";
import axios from "axios";
import { tokens } from "../../theme";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ padding: 3 }}>{children}</Box>}
    </div>
  );
}

export default function TrainingVideos() {
  const token = localStorage.getItem("token");

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [videoList, setVideoList] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);
  
  // const course = location.state?.course;

  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const resources = [
    // Add your resources here
  ];

  const fetchData = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/display/videoList",
        { courseId: 3 },
        {
          headers: { Authorization: token },
        }
      );
      const videoLists = response.data.rows;
      //console.log("videoLists", videoLists);
      setVideoList(videoLists);
      if (videoLists.length > 0) setSelectedVideo(videoLists[0]);
    } catch (error) {
      //console.log("Error fetching data", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Box
      sx={{
        padding: 3,
        mt: "50px",
        minHeight: "100vh",
        display: "flex",
        flexDirection: {
          xs: "column",
          sm: "column",
          md: "column",
          xl: "row",
          lg: "row",
        },
        justifyContent: "space-between",
      }}
      onContextMenu={(e) => e.preventDefault()}
    >
      {/* Main Content */}
      <Box
        sx={{
          flex: 0.65,
          padding: { xs: "20px", sm: "20px 40px" },
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {selectedVideo ? (
          <>
            <Box
              sx={{
                width: "100%",
                maxWidth: "720px",
                marginBottom: "20px",
              }}
            >
              <video
                key={selectedVideo.video_Name}
                src={`${selectedVideo.video_URL}?${token}`}
                controls
                controlsList="nodownload"
                style={{
                  width: "100%",
                  borderRadius: "10px",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                }}
                onContextMenu={(e) => e.preventDefault()}
              />
            </Box>
            <Box sx={{ marginBottom: "10px" }}>
              <Typography
                variant="h5"
                sx={{
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                }}
              >
                {selectedVideo.video_Name}
              </Typography>

              <Box sx={{ width: "100%" }}>
                <Tabs
                  value={selectedTab}
                  onChange={handleTabChange}
                  variant="fullWidth"
                  aria-label="course details tabs"
                  sx={{
                    borderBottom: 1,
                    borderColor: "divider",
                    color: colors.primary[150],
                    "& .MuiTab-root": {
                      fontWeight: "bold",
                      color: colors.primary[150],
                    },
                    "& .MuiTabs-indicator": {
                      backgroundColor: colors.greenAccent[300],
                    },
                  }}
                >
                  <Tab
                    label={
                      <Typography
                        variant="h4"
                        fontWeight="bold"
                        sx={{
                          color:
                            theme.palette.mode === "light" ? "black" : "white",
                        }}
                      >
                        Descriptions
                      </Typography>
                    }
                  />
                  <Tab
                    label={
                      <Typography
                        variant="h4"
                        fontWeight="bold"
                        sx={{
                          color:
                            theme.palette.mode === "light" ? "black" : "white",
                        }}
                      >
                        Resources
                      </Typography>
                    }
                  />
                </Tabs>

                <TabPanel value={selectedTab} index={0}>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    paragraph
                    sx={{ lineHeight: 1.7 }}
                  >
                    {selectedVideo.video_Desc}
                  </Typography>
                </TabPanel>

                <TabPanel value={selectedTab} index={1}>
                  {/* Resources Mapping */}
                  {resources.map((resource, idx) => (
                    <Accordion
                      key={idx}
                      elevation={0}
                      sx={{
                        m: 0,
                        p: 0,
                        backgroundColor: "transparent",
                        "&:before": {
                          display: "none", // Removes the bottom divider line
                        },
                      }}
                    >
                      <AccordionDetails>
                        <ul style={{ paddingLeft: "1.5rem", margin: 0 }}>
                          <li key={resource.id}>
                            <Typography variant="body1">
                              <a
                                href={resource.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  textDecoration: "none",
                                  color: colors.blueAccent[500],
                                }}
                                onMouseOver={(e) =>
                                  (e.target.style.color = "blue")
                                }
                                onMouseOut={(e) =>
                                  (e.target.style.color =
                                    colors.blueAccent[500])
                                }
                              >
                                {resource.title}
                              </a>
                            </Typography>
                          </li>
                        </ul>
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </TabPanel>
              </Box>
            </Box>
          </>
        ) : (
          <Typography variant="h6">No video selected</Typography>
        )}
      </Box>

      {/* Sidebar */}
      <Box
        sx={{
          flex: 0.5,
          position: {
            xs: "relative",
            sm: "relative",
            md: "fixed",
            xl: "fixed",
            lg: "fixed",
          },
          right: 0,
          height: "calc(100vh - 50px)",
          width: { xs: "100%", sm: "100%", md: "28vw", xl: "28vw", lg: "28vw" },
          padding: "20px",
          overflowY: "auto", // Enable vertical scrolling
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          backgroundColor: colors.primary[400],
          marginTop: { xs: "20px", sm: "20px", md: "0", xl: "0", lg: "0" }, // Adjust margin for smaller screens
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontSize: { xs: "1.2rem", sm: "1.5rem" },
              fontWeight: "bold",
            }}
          >
            Events Recording
          </Typography>
        </Box>
        <Divider sx={{ margin: "10px 0" }} />

        <List>
          {videoList.map((video, index) => (
            <ListItem
              key={index}
              onClick={() => setSelectedVideo(video)}
              sx={{
                backgroundColor:
                  selectedVideo?.id === video.id
                    ? colors.grey[800]
                    : "transparent",
                borderRadius: "8px",
                cursor: "pointer",
                margin: 0, // Remove any margin
              }}
            >
              <ListItemText
                primary={`${index + 1}. ${video.video_Name}`}
                secondary={
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <OndemandVideoIcon
                      style={{ fontSize: "15px", marginRight: "5px" }}
                    />
                    {video.video_Length}
                  </div>
                }
                sx={{
                  color: selectedVideo?.id === video.id ? "#fff" : "inherit",
                  fontSize: "10px",
                  margin: 0,
                }}
              />
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  );
}
